import Vue from 'vue'
import Router from 'vue-router'
import store from '@/core/services/store'
import { VERIFY_AUTH } from '@/core/services/store/auth.module'
import { RESET_LAYOUT_CONFIG } from '@/core/services/store/config.module'
import i18n from '@/core/plugins/vue-i18n'

Vue.use(Router)

// Import middleware
import verifyUser from '@/middleware/verifyUser'
import verifyRoute from '@/middleware/verifyRoute'
import verifyLoggedUser from '@/middleware/verifyLoggedUser'
import verifyDashboard from '@/middleware/verifyDashboard'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/view/layout/Layout'),
      name: 'main-menu',
      // redirect: '/compute/virtual-machines',
      redirect:
        process.env.VUE_APP_SHOW_DASHBOARD == 'false'
          ? '/compute/virtual-machines'
          : '/dashboard',
      children: [
        {
          path: '/dashboard',
          name: 'dashboard.dashboard',
          iconName: 'tachometer',
          meta: {
            title: 'dashboard.dashboard',
            middleware: [verifyDashboard],
          },
          type:
            process.env.VUE_APP_SHOW_DASHBOARD == 'false' ? 'detail-page' : '',
          component: () => import('@/view/pages/dashboard/Home'),
        },
        // {
        //   path: '/test-components',
        //   name: 'Test Components',
        //   iconName: 'flask',
        //   type: 'detail-page',
        //   meta: {
        //     title: 'Test Components',
        //     middleware: [verifyUser, verifyLoggedUser],
        //   },
        //   component: () => import('@/view/pages/TestComponents')
        // },
        // {
        //   path: '/test-detail-components',
        //   name: 'Test Detail Components',
        //   iconName: 'flask',
        //   type: 'detail-page',
        //   meta: {
        //     title: 'Test Detail Components',
        //     middleware: [verifyUser, verifyLoggedUser],
        //   },
        //   component: () => import('@/view/pages/TestDetailComponents'),
        // },
        {
          path: '/compute',
          redirect: '/compute/virtual-machines',
          name: 'servers.compute',
          iconName: 'microchip',
          component: () => import('@/view/pages/compute/Compute'),
          children: [
            {
              path: '/compute/virtual-machines',
              name: 'servers.vm',
              component: () => import('@/view/pages/compute/VirtualMachines'),
              meta: {
                title: 'servers.vm',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/compute/virtual-machines/:id',
              name: 'servers.vmDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.vmDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () =>
                import('@/view/pages/compute/VirtualMachineDetail'),
            },
            {
              path: '/compute/templates',
              name: 'servers.templates',
              component: () => import('@/view/pages/compute/Templates'),
              meta: {
                title: 'servers.templates',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/compute/templates/:id',
              name: 'servers.templateDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.templateDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/compute/TemplateDetail'),
            },
          ],
        },
        {
          path: '/storage',
          redirect: '/storage/virtual-disks',
          name: 'servers.storage',
          iconName: 'hdd',
          component: () => import('@/view/pages/storage/Storage'),
          children: [
            {
              path: '/storage/virtual-disks',
              name: 'servers.vdImage',
              component: () => import('@/view/pages/storage/VirtualDisks'),
              meta: {
                title: 'servers.vdImage',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/storage/plusclouds-cs',
              name: 'servers.plusCloudsCs',
              component: () => import('@/view/pages/storage/PlusCloudsCS'),
              meta: {
                title: 'servers.plusCloudsCs',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/storage/plusclouds-cs/:id',
              name: 'servers.plusCloudsCsDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.plusCloudsCsDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () =>
                import('@/view/pages/storage/PlusCloudsCSDetail'),
            },
          ],
        },
        {
          path: '/networking',
          redirect: '/networking/domain-name-service',
          name: 'global.networking',
          iconName: 'network-wired',
          component: () => import('@/view/pages/networking/Networking'),
          children: [
            {
              path: '/networking/virtual-network-cards',
              name: 'servers.vnc',
              component: () =>
                import('@/view/pages/networking/VirtualNetworkCards'),
              meta: {
                title: 'servers.vnc',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/private-zones',
              name: 'servers.virtualZones',
              component: () => import('@/view/pages/networking/VirtualZones'),
              meta: {
                title: 'servers.virtualZones',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/ip-management',
              name: 'servers.ipManagement',
              component: () => import('@/view/pages/networking/IPManagement'),
              meta: {
                title: 'servers.ipManagement',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/nat',
              name: 'servers.natRules',
              component: () => import('@/view/pages/networking/NAT'),
              meta: {
                title: 'servers.natRules',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/proxy',
              name: 'servers.proxyRules',
              component: () => import('@/view/pages/networking/Proxy'),
              meta: {
                title: 'servers.proxyRules',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/domain-name-service',
              name: 'servers.advancedDns',
              component: () => import('@/view/pages/networking/DNS'),
              meta: {
                title: 'servers.advancedDns',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/domain-name-service/:id',
              name: 'servers.dnsDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.dnsDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/networking/DNSDetail'),
            },
            {
              path: '/networking/gateways',
              name: 'gateways.gateways',
              component: () => import('@/view/pages/networking/Gateways'),
              meta: {
                title: 'gateways.gateways',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/networking/gateways/:id',
              name: 'gateways.gatewaysDetail',
              type: 'detail-page',
              meta: {
                title: 'gateways.gatewaysDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/networking/GatewaysDetail'),
            },
          ],
        },
        {
          path: '/services',
          redirect: '/services/networking/domain-name-service',
          name: 'global.services',
          iconName: 'list',
          component: () => import('@/view/pages/services/Services'),
          children: [
            {
              path: '/services/ansible',
              name: 'servers.ansible',
              component: () => import('@/view/pages/services/Ansible'),
              meta: {
                title: 'servers.ansible',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/ansible/:id',
              name: 'servers.ansibleDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.ansibleDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/services/AnsibleDetail'),
            },
            {
              path: '/services/message-queuing',
              name: 'servers.messageQueuing',
              component: () => import('@/view/pages/services/MessageQueuing'),
              meta: {
                title: 'servers.messageQueuing',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/database-services',
              name: 'servers.databaseService',
              component: () => import('@/view/pages/services/DatabaseService'),
              meta: {
                title: 'servers.databaseService',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/streaming',
              name: 'servers.streaming',
              component: () => import('@/view/pages/services/Streaming'),
              meta: {
                title: 'servers.streaming',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/streaming/:id',
              name: 'servers.streamingDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.streamingDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/services/StreamingDetail'),
            },
            {
              path: '/services/stash',
              name: 'global.stash',
              // type: 'detail-page',
              component: () => import('@/view/pages/services/stash/Stash'),
              meta: {
                title: 'global.stash',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/stash/wizard',
              name: 'detail.stash.wizard',
              type: 'detail-page',
              component: () =>
                import('@/view/pages/services/stash/StashWizard'),
              meta: {
                title: 'detail.stash.wizard',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/scheduler',
              name: 'scheduler.scheduler',
              // type: 'detail-page',
              component: () => import('@/view/pages/services/Scheduler'),
              meta: {
                title: 'scheduler.scheduler',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/scheduler/:id',
              name: 'scheduler.schedulerDetail',
              type: 'detail-page',
              meta: {
                title: 'scheduler.schedulerDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/services/SchedulerDetail'),
            },
            {
              path: '/services/registry',
              name: 'registry.plusCloudsRegistry',
              component: () => import('@/view/pages/services/Registry'),
              meta: {
                title: 'registry.plusCloudsRegistry',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/registry/:id',
              name: 'registry.plusCloudsRegistryDetail',
              type: 'detail-page',
              meta: {
                title: 'registry.plusCloudsRegistryDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/services/RegistryDetail'),
            },
            {
              path: '/services/iam',
              name: 'iam.plusCloudsIAM',
              component: () => import('@/view/pages/services/iam/iamList'),
              meta: {
                title: 'iam.plusCloudsIAM',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/services/iam/:id',
              name: 'iam.plusCloudsIAMDetail',
              type: 'detail-page',
              component: () => import('@/view/pages/services/iam/iamDetail'),
              meta: {
                title: 'iam.plusCloudsIAMDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
          ],
        },
        {
          path: '/my-cloud',
          redirect: '/my-cloud/cloud-nodes',
          name: 'servers.myCloud',
          iconName: 'cloud',
          component: () => import('@/view/pages/my-cloud/MyCloud'),
          children: [
            {
              path: '/my-cloud/cloud-nodes',
              name: 'servers.cloudNode',
              component: () => import('@/view/pages/my-cloud/CloudNodes'),
              meta: {
                title: 'servers.cloudNode',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/my-cloud/cloud-nodes/:id',
              name: 'servers.cloudNodeDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.cloudNodeDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () => import('@/view/pages/my-cloud/CloudNodeDetail'),
            },
            {
              path: '/my-cloud/compute-pools',
              name: 'servers.computePools',
              component: () => import('@/view/pages/my-cloud/ComputePools'),
              meta: {
                title: 'servers.computePools',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/my-cloud/storage-pools',
              name: 'servers.storagePools',
              component: () => import('@/view/pages/my-cloud/StoragePools'),
              meta: {
                title: 'servers.storagePools',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/my-cloud/storage-pools/:id',
              name: 'servers.storagePoolsDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.storagePoolsDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () =>
                import('@/view/pages/my-cloud/StoragePoolsDetail'),
            },
            {
              path: '/my-cloud/network-pools',
              name: 'servers.networkPools',
              component: () => import('@/view/pages/my-cloud/NetworkPools'),
              meta: {
                title: 'servers.networkPools',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/my-cloud/streaming-clusters',
              name: 'servers.streamingClusters',
              component: () =>
                import(
                  '@/view/pages/my-cloud/streaming-cluster/StreamingClusters'
                ),
              meta: {
                title: 'servers.streamingClusters',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/my-cloud/streaming-clusters/:id',
              name: 'servers.streamingClustersDetail',
              type: 'detail-page',
              meta: {
                title: 'servers.streamingClustersDetail',
                middleware: [verifyUser, verifyLoggedUser],
              },
              component: () =>
                import(
                  '@/view/pages/my-cloud/streaming-cluster/StreamingClusterDetail'
                ),
            },
          ],
        },
        {
          path: '/communication',
          redirect: '/communication/communication-channels',
          name: 'communication.communication',
          type: 'detail-page',
          component: () => import('@/view/pages/communication/Communication'),
          children: [
            {
              path: '/communication/communication-channels',
              name: 'communication.communicationChannels',
              component: () =>
                import('@/view/pages/communication/CommunicationChannels'),
              meta: {
                title: 'communication.communicationChannels',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
            {
              path: '/communication/news-channels',
              name: 'communication.newsChannels',
              component: () =>
                import('@/view/pages/communication/NewsChannels'),
              meta: {
                title: 'communication.newsChannels',
                middleware: [verifyUser, verifyLoggedUser],
              },
            },
          ],
        },
        {
          path: '/gift-codes',
          name: 'giftcode.giftcodes',
          type: 'detail-page',
          component: () => import('@/view/pages/dashboard/Giftcodes'),
          meta: {
            title: 'giftcode.giftcodes',
            middleware: [verifyUser, verifyLoggedUser],
          },
        },
        {
          path: '/account',
          name: 'global.account',
          type: 'detail-page',
          meta: {
            title: 'global.account',
          },
          component: () => import('@/view/pages/account/General'),
        },
        {
          path: '/support',
          name: 'account.support',
          type: 'detail-page',
          meta: {
            title: 'account.support',
          },
          component: () => import('@/view/pages/account/Support'),
        },
        {
          path: '/payment',
          name: 'account.payment',
          type: 'detail-page',
          meta: {
            title: 'account.payment',
          },
          component: () => import('@/view/pages/account/Payment'),
        },
        {
          path: '/personal-access-token',
          name: 'personalAccessTokens',
          type: 'detail-page',
          meta: {
            title: 'token.personalAccessTokens',
          },
          component: () => import('@/view/pages/account/PersonalAccessToken'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/view/pages/auth/Auth'),
      children: [
        {
          path: '/login',
          name: 'login',
          meta: {
            title: 'global.login',
            middleware: [verifyRoute],
          },
          component: () => import('@/view/pages/auth/Login'),
        },
      ],
    },
    {
      // the 404 route, when none of the above matches
      path: '/callback',
      name: 'callback',
      meta: {
        title: 'global.pageCallback',
      },
      component: () => import('@/view/pages/callback/Callback'),
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      // the 404 route, when none of the above matches
      path: '/404',
      name: '404',
      meta: {
        title: 'global.page404',
      },
      component: () => import('@/view/pages/error/Error-1'),
    },
  ],
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  // Change page title before each page load
  //document.title = (to.meta.title ? to.meta.title + ' - ' : '') + process.env.VUE_APP_TITLE
  document.title =
    (to.meta.title ? i18n.t(to.meta.title) + ' - ' : '') +
    process.env.VUE_APP_TITLE

  next()

  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next)

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG)

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      store,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  } else {
    return next()
  }
})
export default router
